require([
    "jquery", 
    "ads",
    "ModuleLoader",
    "utilities", 
    "logging",
    "storage",
    "onetrust",
    "analytics",
    "gtm",
    "pushnami",
    "delayedtasks",
    "admiral",    
    "bootstrap"
], function ($, ads, moduleLoader, utilities, logging, storage, onetrust, analytics, gtm, pushnami, delayedtasks, admiral) {
    "use strict";

    // Initialize patheos utilities
    utilities.init();

    // Initialize storage 
    storage.init();

    // Initialize OneTrust
    onetrust.init();

    // initialize analytics
    analytics.init();

    // initialize GTM
    gtm.init();

    // initialize pushnami
    pushnami.init();
    
    // initialize dfp
    logging.log("Starting Ad Init");
    $.when(ads.init()).then(function() {
        delayedtasks.init();

        // handle ad config preloading
        if (ads.preload()) {
            logging.log("Starting Ad Run");
            ads.start();
            ads.runAfterAdsLoaded(function () {
                loadModulesNoAds();
            });            
        } else {
            loadModulesWithAds();
        }

        // Load Taboola Later
        delayedtasks.registerTask(function () {
            console.log('Loading Taboola Header Script');

            window._taboola = window._taboola || [];
            _taboola.push({ photo: 'auto' });
            !function (e, f, u, i) {
                if (!document.getElementById(i)) {
                    e.async = 1;
                    e.src = u;
                    e.id = i;
                    f.parentNode.insertBefore(e, f);
                }
            }(document.createElement('script'),
                document.getElementsByTagName('script')[0],
                '//cdn.taboola.com/libtrc/bnmedia-patheos1/loader.js',
                'tb_loader_script');
            if (window.performance && typeof window.performance.mark == 'function') { window.performance.mark('tbl_ic'); }
        });
    });

    
    function loadModulesNoAds() {
        $(function () {
            logging.log("Starting module loading without ads");
            moduleLoader.loadPendingModules($('div[data-ux-module]').not('.DFPAdSlot, .dfp-page-config')).done(function () {
                // anything that neeeds to run globally when all modules are loaded goes here        
                onModuleLoadComplete();
            });
        });
    }

    function loadModulesWithAds() {
        $(function () {
            logging.log("Starting module loading with ads");
            moduleLoader.loadPendingModules($('.DFPAdSlot, .dfp-page-config')).done(function () {
                // Start DFP
                ads.start();

                // Load rest of the modules
                moduleLoader.loadPendingModules().done(function () {
                    // anything that neeeds to run globally when all modules are loaded goes here        

                    onModuleLoadComplete();
                });
            });
        })
    }

    function onModuleLoadComplete() {
        // Load nativo if Ad-Free Subscription not detected or Ad-Free is disabled
        if (admiral.isEnabled()) { 
            admiral.checkUserSubscribed(function () {
                ;
            }, function () {
                // Load Nativo
                utilities.load3rdPartyScript("//s.ntv.io/serve/load.js");
            });
        } else {
            // Load Nativo
            utilities.load3rdPartyScript("//s.ntv.io/serve/load.js");
        }

        // fix youtube videos
        if(utilities.IsPhone()) {
            ;
            utilities.fixYouTubeResponsive();
        }
    }
});
define("main", function(){});

